import { useState, useCallback } from 'react';

// Format number with commas while typing (whole numbers only)
export const useNumberFormat = (initialValue = '') => {
  const [displayValue, setDisplayValue] = useState(initialValue);
  const [numericValue, setNumericValue] = useState(initialValue);

  const formatWithCommas = (value) => {
    // Remove all non-digit characters
    const cleaned = value.replace(/\D/g, '');
    
    if (!cleaned) return '';
    
    // Format with commas
    return cleaned.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  const handleChange = useCallback((e) => {
    let input = e.target.value;
    
    // Remove all commas first
    const numeric = input.replace(/,/g, '');
    
    // Only allow digits
    if (numeric && !/^\d+$/.test(numeric)) {
      return;
    }
    
    // Format with commas for display
    const formatted = formatWithCommas(numeric);
    
    setDisplayValue(formatted);
    setNumericValue(numeric);
  }, []);

  const reset = useCallback(() => {
    setDisplayValue('');
    setNumericValue('');
  }, []);

  return {
    displayValue,
    numericValue,
    handleChange,
    reset,
    setValue: (value) => {
      const formatted = formatWithCommas(value);
      setDisplayValue(formatted);
      setNumericValue(value);
    }
  };
};